import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error
    console.error('React Error Boundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div style={{
          minHeight: '100vh',
          backgroundColor: '#f3f4f6',
          fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, sans-serif',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            textAlign: 'center',
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '16px',
            border: '1px solid #e5e7eb',
            maxWidth: '500px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h2 style={{ color: '#dc2626', marginBottom: '8px' }}>Something went wrong</h2>
            <p style={{ color: '#6b7280', marginBottom: '20px' }}>
              An unexpected error occurred while loading the Google Ads generator.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#1e40af',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                cursor: 'pointer',
                fontFamily: 'Poppins',
                fontWeight: '500'
              }}
            >
              Reload Page
            </button>
            {this.props.showDetails && (
              <details style={{ 
                marginTop: '20px', 
                textAlign: 'left',
                backgroundColor: '#f9fafb',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '12px',
                color: '#374151'
              }}>
                <summary style={{ cursor: 'pointer', fontWeight: '500' }}>Error Details</summary>
                <pre style={{ 
                  marginTop: '8px', 
                  whiteSpace: 'pre-wrap',
                  fontSize: '11px'
                }}>
                  {this.state.error && this.state.error.toString()}
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;